import { ReactElement } from 'react';
import { LiteracyScreeningGradesModel } from '../../../types/LiteracyScreeningGradesModel';
import { LITERACY_SCREENING_BEGINNING_OF_YEAR_SESSION } from '../../../types/LiteracyScreeningModel';
import LiteracyScreeningSessionPanel, {
  LiteracyScreeningSessionEditState,
} from './LiteracyScreeningSessionPanel';

export { calcInterventionPercentage } from './LiteracyScreeningSessionPanel';
export type {
  LiteracyScreeningBoyEditState,
  LiteracyScreeningBoyGridRow,
  LiteracyScreeningSessionEditState,
  LiteracyScreeningSessionGridRow,
} from './LiteracyScreeningSessionPanel';

interface LiteracyScreeningBeginningOfYearPanelProps {
  grades: LiteracyScreeningGradesModel[];
  schoolYear: string;
  schoolName?: string;
  disabled?: boolean;
  resetKey?: number;
  onEditStateChange?: (state: LiteracyScreeningSessionEditState) => void;
}

const LiteracyScreeningBeginningOfYearPanel = ({
  grades,
  schoolYear,
  schoolName,
  disabled = false,
  resetKey,
  onEditStateChange,
}: LiteracyScreeningBeginningOfYearPanelProps): ReactElement => (
  <LiteracyScreeningSessionPanel
    heading="Beginning of Year Screening"
    session={LITERACY_SCREENING_BEGINNING_OF_YEAR_SESSION}
    grades={grades}
    schoolYear={schoolYear}
    schoolName={schoolName}
    disabled={disabled}
    resetKey={resetKey}
    onEditStateChange={onEditStateChange}
  />
);

export default LiteracyScreeningBeginningOfYearPanel;
